import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { Store } from '@ngrx/store';
import * as ErrorActions from '../store/error/actions/error.actions';

/**
 * Global Error Handler
 *
 * Catches all uncaught errors in the application and dispatches them
 * to the NgRx error store for centralized error handling and display.
 *
 * This handles errors that are not caught by HTTP interceptors or
 * component-level error handling.
 *
 * Note: Uses lazy injection via Injector to avoid circular dependency issues
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private injector = inject(Injector);

  handleError(error: Error): void {
    // Log to console for debugging
    console.error('Global error caught:', error);

    // Lazy-inject Store to avoid circular dependency
    try {
      const store = this.injector.get(Store);
      store.dispatch(
        ErrorActions.GlobalError({
          error: {
            statusCode: 500,
            message: error.message || 'An unexpected error occurred',
            timestamp: new Date(),
            actionType: 'Uncaught Error',
            details: error,
          },
        }),
      );
    } catch (injectionError) {
      // If store isn't available yet, just log to console
      console.error('Could not dispatch error to store:', injectionError);
    }
  }
}
